export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ayer"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chat"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hoy"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lunes"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Martes"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Miércoles"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jueves"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Viernes"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sábado"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Domingo"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["enero"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["febrero"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["marzo"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["abril"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["mayo"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["junio"])},
  "17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["julio"])},
  "18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["agosto"])},
  "19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["septiembre"])},
  "20": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["octubre"])},
  "21": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["noviembre"])},
  "22": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["diciembre"])},
  "23": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tú"])},
  "24": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administrador"])}
}